// extracted by mini-css-extract-plugin
export default {"container":"_o-z","ratingLayout":"ap-z","ratingLabel":"bp-z","nonInteractiveRatingLabel":"cp-z"};